import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=b88b3e7e"
import script from "./CopyModal.vue?vue&type=script&lang=js"
export * from "./CopyModal.vue?vue&type=script&lang=js"
import style0 from "./CopyModal.vue?vue&type=style&index=0&id=b88b3e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports